import { toFullName } from '@repo/toolkit/to-full-name'
import { ClockIcon, LocationOneIcon, TelephoneIcon, UserTwoIcon } from '@repo/ui/icons'
import Loader from '@repo/ui/loader'
import { useQuery } from '@tanstack/react-query'

import { getCenter } from '../../../../api/centers/get-center'
import { getEnrollmentCenter } from '../../../../api/enrollments/get-enrollment-center'
import { useDataProps } from '../../../../lib/hooks/use-data-props'
import {
  centerBasicFields,
  CenterBasicType
} from '../../../../lib/types/fields/enrollments/center'
import { DataProps } from '../../../../lib/types/utils'
import { formatPhoneNumber } from '../../../../utils/functions/format-phone-number'
import OverviewCard from '../overview-card'

type Props = {
  enrollmentId: number
}

const ClientEnrollmentCenterCard = (props: DataProps<CenterBasicType, Props>) => {
  const { enrollmentId } = props
  const { data } = useQuery({
    queryKey: ['client-enrollment-center', enrollmentId, centerBasicFields],
    queryFn: async () => getEnrollmentCenter(enrollmentId, centerBasicFields)
  })

  const { data: center } = useDataProps(props, (id) => getCenter(id, 'LIGHT'))

  if (!data) return <Loader center />

  return (
    <OverviewCard
      title={`Collège de séjour : ${data.name}`}
      bulletPoints={[
        {
          icon: LocationOneIcon,
          label: data.journeyPlace?.address ?? '-'
        },
        {
          icon: UserTwoIcon,
          label: center?.diffusedCenterManager
            ? `Directeur : ${toFullName(center?.diffusedCenterManager?.staff.firstName, center?.diffusedCenterManager?.staff.lastName, { options: { mode: 'lastname-firstname' } })}`
            : 'Directeur : -'
        },
        {
          icon: ClockIcon,
          label: 'Vous pouvez joindre un responsable entre 9h30 et 11h00 heure locale.'
        },
        {
          icon: TelephoneIcon,
          label: `Téléphone: ${
            center?.diffusedCenterManager?.facNumber
              ? formatPhoneNumber(center?.diffusedCenterManager?.facNumber)
              : center?.diffusedCenterManager?.staff.phoneNumber
                ? formatPhoneNumber(center?.diffusedCenterManager?.staff.phoneNumber)
                : '-'
          }`
        }
      ]}
      imagePath="/college.png"
    />
  )
}

export default ClientEnrollmentCenterCard
